/* SVADEZI theme JS — scroll reveal, mobile nav, PDP gallery */
(function () {
  // scroll reveal
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' })
    : null;
  /* The app staggers reveals rather than firing a whole grid at once:
     ProductCard uses delay={(i % 4) * 60} and section blocks step in 60-80ms
     apart. Without this every card in a grid animates simultaneously, which is
     the main reason the motion read differently from the reference.
     A `.reveal` that already carries an inline transition-delay is left alone,
     so markup can still opt out or override. */
  function applyStagger(el) {
    if (el.style.transitionDelay) return;
    var parent = el.parentElement;
    if (!parent) return;
    var sibs = parent.children, idx = 0, seen = 0, i;
    for (i = 0; i < sibs.length; i++) {
      if (sibs[i] === el) { idx = seen; break; }
      if (sibs[i].classList && sibs[i].classList.contains('reveal')) seen++;
    }
    // only cascade when there is actually a group to cascade
    if (seen === 0 && idx === 0) {
      var total = parent.querySelectorAll(':scope > .reveal').length;
      if (total < 2) return;
    }
    el.style.transitionDelay = (idx % 4) * 60 + 'ms';
  }
  function bindReveal(root) {
    (root || document).querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      applyStagger(el);
      if (io) { io.observe(el); } else { el.classList.add('is-visible'); }
    });
  }
  bindReveal();

  // mobile nav
  var t = document.querySelector('[data-menu-toggle]');
  var m = document.querySelector('[data-mobile-nav]');
  var navPill = document.querySelector('[data-nav-pill]');
  if (t && m) {
    t.addEventListener('click', function () {
      var open = m.classList.toggle('open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* Forces the pill to its solid (dark) treatment while the menu is open,
         so the toggle's hamburger->X animation reads against the dark scrim
         regardless of scroll position, instead of sitting in a near-invisible
         light pill at scrollY 0. Pairs with the z-index fix in
         theme-pill-arrow.css section 3 — the toggle was previously rendered
         UNDER its own full-screen menu and unreachable once open. */
      if (navPill) navPill.classList.toggle('menu-open', open);
    });
  }

  // PDP gallery
  var main = document.querySelector('[data-gallery-main]');
  if (main) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        var alt = b.getAttribute('data-alt') || '';
        if (src) { main.src = src; main.alt = alt; }
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', o === b ? 'true' : 'false');
        });
      });
    });
  }

  // qty steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var step = parseInt(btn.getAttribute('data-step'), 10) || 1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
      });
    });
  });

  /* ---------- hero: scroll-scrub video ---------- */
  (function () {
    var host = document.querySelector('[data-hero-scroll]');
    if (!host) return;
    var video = host.querySelector('[data-hero-video]');
    var copy  = host.querySelector('[data-hero-copy]');
    var cue   = host.querySelector('[data-hero-cue]');
    if (!video) return;

    var mqMobile = window.matchMedia('(max-width: 767px)');
    var reduce   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raf = 0, current = 0, lastSet = -1;
    var MIN_DELTA = 1 / 60;

    function chooseSource() {
      var src = mqMobile.matches ? host.dataset.mobile : host.dataset.desktop;
      if (src && video.getAttribute('src') !== src) {
        video.setAttribute('src', src);
        try { video.load(); } catch (e) {}
      }
    }

    function loopMode() {
      cancelAnimationFrame(raf);
      video.loop = true; video.muted = true;
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    }

    function scrubMode() {
      video.loop = false; video.muted = true; video.pause();
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(tick);
    }

    function tick() {
      var rect = host.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      if (video.readyState >= 2 && video.duration && isFinite(video.duration) && scrollable > 0) {
        var passed = Math.min(Math.max(-rect.top, 0), scrollable);
        var target = passed / scrollable;
        current += (target - current) * 0.1;
        var clamped = Math.min(Math.max(current, 0), 1);

        var maxT = Math.max(0, video.duration - 0.05);
        var t = Math.min(clamped * video.duration, maxT);
        if (Math.abs(t - lastSet) > MIN_DELTA) {
          try { video.currentTime = t; lastSet = t; } catch (e) {}
        }
        // fade the wordmark + cue out as the film plays
        if (copy) copy.style.opacity = String(Math.max(0, 1 - clamped * 2.4));
        if (cue)  cue.style.opacity  = String(Math.max(0, 1 - clamped * 4));
      }
      raf = requestAnimationFrame(tick);
    }

    function apply() {
      chooseSource();
      if (mqMobile.matches || reduce) {
        if (copy) copy.style.opacity = '1';
        if (cue) cue.style.opacity = '1';
        loopMode();
      } else {
        scrubMode();
      }
    }

    apply();
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', apply);
    else if (mqMobile.addListener) mqMobile.addListener(apply);
  })();
})();

/* ---- metal studio: finish + metal cross-fade ---- */
(function () {
  var studio = document.getElementById('studio');
  if (!studio) return;
  var imgs = studio.querySelectorAll('[data-finish-img]');
  var finishBtns = studio.querySelectorAll('[data-finish]');
  var metalBtns = studio.querySelectorAll('[data-metal]');
  var finish = finishBtns.length ? finishBtns[0].getAttribute('data-finish') : 'yellow';
  var metal = metalBtns.length ? metalBtns[0].getAttribute('data-metal') : '18K';

  function setActive(list, attr, val) {
    list.forEach(function (b) {
      var on = b.getAttribute(attr) === val;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function render() {
    var silver = metal === '925';
    var shown = silver ? 'white' : finish;
    imgs.forEach(function (img) {
      var on = img.getAttribute('data-finish-img') === shown;
      img.style.opacity = on ? '1' : '0';
      img.style.filter = (on && silver) ? 'saturate(0) brightness(1.08) contrast(0.96)' : '';
    });
    finishBtns.forEach(function (b) {
      b.disabled = silver;
      b.classList.toggle('is-disabled', silver);
    });
    setActive(finishBtns, 'data-finish', silver ? null : finish);
    setActive(metalBtns, 'data-metal', metal);
  }

  finishBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      finish = b.getAttribute('data-finish');
      render();
    });
  });
  metalBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      metal = b.getAttribute('data-metal');
      render();
    });
  });
  render();
})();

/* ---- certificate flip card ---- */
(function () {
  document.querySelectorAll('[data-cert-flip]').forEach(function (card) {
    var flip = function () { card.classList.toggle('is-flipped'); };
    card.addEventListener('click', flip);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); }
    });
  });
})();

/* ---- publish sticky header-stack height as --header-h ---- */
(function () {
  var stack = document.querySelector('[data-header-stack]');
  if (!stack) return;
  var set = function () {
    document.documentElement.style.setProperty('--header-h', stack.offsetHeight + 'px');
  };
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(stack);
  window.addEventListener('resize', set);
  window.addEventListener('load', set);
})();

/* ---- floating nav: solid on scroll, retract on scroll-down ---- */
(function () {
  var wrap = document.querySelector('[data-nav-float]');
  var pill = document.querySelector('[data-nav-pill]');
  if (!wrap || !pill) return;
  var stack = document.querySelector('[data-header-stack]');
  var isHome = document.body.classList.contains('template-index');
  var last = window.scrollY, ticking = false;

  // Set the offset in real pixels rather than relying on calc(var()) resolving.
  function offset() {
    return (stack ? stack.offsetHeight : 44) + 14;
  }

  function apply() {
    var y = window.scrollY;
    /* The retract is HOMEPAGE-ONLY, matching the reference app. Measured on
       svadezi.lovable.app: the homepage pill (--header-h 66px) drops to
       top:-100px on scroll-down and returns to header-h+14 (80px) on
       scroll-up, while /collections and /made-to-order (--header-h 28px) hold
       top:42px through 2000px of scrolling in both directions — they never
       retract. Without the isHome gate every inner page hid its nav on
       scroll-down, which the reference never does. */
    var hidden = isHome && y > 120 && y > last;
    pill.classList.toggle('is-solid', !isHome || y > 40);
    wrap.classList.toggle('is-hidden', hidden);
    wrap.style.top = hidden ? '-100px' : offset() + 'px';
    last = y;
    ticking = false;
  }

  apply();
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
  }, { passive: true });
  window.addEventListener('resize', apply);
  window.addEventListener('load', apply);
  if (window.ResizeObserver && stack) new ResizeObserver(apply).observe(stack);
})();

/* ---- silver interstitial then redirect ---- */
(function () {
  var btn = document.querySelector('[data-silver-trigger]');
  var veil = document.querySelector('[data-silver-veil]');
  if (!btn || !veil) return;
  var video = veil.querySelector('[data-silver-veil-video]');
  var caption = veil.querySelector('[data-silver-caption]');
  var url = btn.getAttribute('data-silver-url');
  var mobile = window.matchMedia('(max-width: 767px)').matches;
  var src = (mobile ? btn.getAttribute('data-silver-video-mobile') : btn.getAttribute('data-silver-video')) || '';
  var limit = parseInt(btn.getAttribute('data-silver-timeout'), 10) || 5500;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var went = false;

  var go = function () {
    if (went) return;
    went = true;
    veil.classList.add('is-closing');
    setTimeout(function () { window.location.href = url; }, 150);
  };

  btn.addEventListener('click', function () {
    if (reduce || !src) { setTimeout(go, 150); veil.hidden = false; veil.classList.add('is-on'); return; }
    veil.hidden = false;
    requestAnimationFrame(function () { veil.classList.add('is-on'); });
    setTimeout(function () { caption.classList.add('is-in'); }, 60);
    video.src = src;
    ['ended', 'error', 'stalled'].forEach(function (e) { video.addEventListener(e, go); });
    var p = video.play();
    if (p && p.catch) p.catch(go);
    setTimeout(function () { if (video.paused) go(); }, 600);
    setTimeout(go, limit);
  });
})();


/* ---- PDP: hover zoom + sticky buy bar ----
   Variant sync moved to assets/pdp-variant-sync.js so the buy path (which
   variant ends up in the cart) lives in one auditable file. Do not re-add a
   variant matcher here: two handlers writing [data-variant-select] would race,
   and the naive one silently keeps a stale id past the 250-variant cap. */
(function () {
  var form = document.getElementById('pdp-form');
  if (!form) return;

  // follow-cursor zoom on the main image
  var stage = document.querySelector('[data-zoom]');
  var img = document.querySelector('[data-zoom-img]');
  if (stage && img && window.matchMedia('(hover: hover)').matches) {
    var locked = false;
    var apply = function (e, on) {
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = on ? 'scale(1.6)' : 'scale(1)';
    };
    stage.addEventListener('mousemove', function (e) { apply(e, true); });
    stage.addEventListener('mouseleave', function () {
      if (locked) return;
      img.style.transform = 'scale(1)';
    });
    stage.addEventListener('click', function (e) { locked = !locked; apply(e, locked); });
  }

  // sticky buy bar once the hero buy box scrolls away
  var hero = document.querySelector('[data-pdp-hero]');
  var bar = document.querySelector('[data-pdp-sticky]');
  if (hero && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting);
        bar.setAttribute('aria-hidden', en.isIntersecting ? 'true' : 'false');
      });
    }, { rootMargin: '-40% 0px 0px 0px' }).observe(hero);
  }
  var stickyAdd = document.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function () { form.submit(); });
})();